import { render, staticRenderFns } from "./MenuCard.vue?vue&type=template&id=a3d4b8de&scoped=true"
import script from "./MenuCard.vue?vue&type=script&lang=js"
export * from "./MenuCard.vue?vue&type=script&lang=js"
import style0 from "./MenuCard.vue?vue&type=style&index=0&id=a3d4b8de&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a3d4b8de",
  null
  
)

export default component.exports